import { render, staticRenderFns } from "./button.vue?vue&type=template&id=7dc5fcb5&scoped=true"
import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"
import style0 from "./button.vue?vue&type=style&index=0&id=7dc5fcb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc5fcb5",
  null
  
)

export default component.exports